<template>
  <div class="actions">
    <v-tooltip top v-if="!hideView && permissions.orders.actions.view">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="$emit('view', value)"
          class="mr-2"
        >
          <v-icon>mdi-eye-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.orders.actions.view }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.orders.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="$emit('edit', value)"
          class="mr-2"
        >
          <v-icon>mdi-playlist-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.orders.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          @click.stop="repeatOrder(value)"
          icon
          small
          class="mr-2"
        >
          <v-icon medium>
            mdi-repeat
          </v-icon>
        </v-btn>
      </template>
      <span>{{ lang.orders.actions.repeat }}</span>
    </v-tooltip>
    <!-- <Status
      :value="value"
      @input="(e) => $emit('input', e)"
    />
    <v-tooltip top v-if="permissions.orders.actions.paid">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="paid(value)"
          class="mr-2"
          :color="(value.paid ? 'green' : 'grey')"
          :disabled="value.status === 6"
        >
          <v-icon>mdi-cash-multiple</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.orders.payment.paid }}</span>
    </v-tooltip> -->
    <template v-if="value.status !== 8">
      <v-tooltip top v-if="permissions.orders.actions.cancel">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="cancel(value)"
            class="mr-2"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.orders.actions.cancel }}</span>
      </v-tooltip>
    </template>
    <template v-else>
      <v-tooltip top v-if="permissions.orders.actions.cancel">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="uncancel(value)"
            class="mr-2"
          >
            <v-icon>mdi-backup-restore</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.orders.actions.uncancel }}</span>
      </v-tooltip>
    </template>
    <v-tooltip top v-if="permissions.orders.actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="remove(value)"
          class="mr-2"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.orders.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
// import Status from './actions/Status'

import appdata from '@/mixins/appdata'
import orders from '../mixins/index'

export default {
  // components: { Status },
  mixins: [ appdata, orders ],
  props: {
    value: {
      type: Object,
      required: true
    },
    hideView: {
      type: Boolean,
      default: false
    }
  }
}
</script>
